var _linearGradient, _clipPath, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 20,
    role: "img",
    "aria-label": "Bootstrap",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bootstrap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 81,
    height: 20,
    fill: "#7952b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmZmZmIiByb2xlPSJpbWciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+Qm9vdHN0cmFwPC90aXRsZT48cGF0aCBkPSJNMTEuNzcgMTEuMjRIOS45NTZWOC4yMDJoMi4xNTJjMS4xNyAwIDEuODM0LjUyMiAxLjgzNCAxLjQ2NiAwIDEuMDA4LS43NzMgMS41NzItMi4xNzQgMS41NzJ6bS4zMjQgMS4yMDZIOS45NTd2My4zNDhoMi4yMzFjMS40NTkgMCAyLjIzMi0uNTg1IDIuMjMyLTEuNjg1cy0uNzk1LTEuNjYzLTIuMzI2LTEuNjYzek0yNCAxMS4zOXYxLjIxOGMtMS4xMjguMTA4LTEuODE3Ljk0NC0yLjIyNiAyLjI2OC0uNDA3IDEuMzE5LS40NjMgMi45MzctLjQyIDQuMTg2LjA0NSAxLjMtLjk2OCAyLjUtMi4zMzcgMi41SDQuOTg1Yy0xLjM3IDAtMi4zODMtMS4yLTIuMzM3LTIuNS4wNDMtMS4yNDktLjAxMy0yLjg2Ny0uNDItNC4xODYtLjQxLTEuMzI0LTEuMS0yLjE2LTIuMjI4LTIuMjY4VjExLjM5YzEuMTI4LS4xMDggMS44MTktLjk0NCAyLjIyNy0yLjI2OC40MDgtMS4zMTkuNDY0LTIuOTM3LjQyLTQuMTg2LS4wNDUtMS4zLjk2OC0yLjUgMi4zMzgtMi41aDE0LjAzMmMxLjM3IDAgMi4zODIgMS4yIDIuMzM3IDIuNS0uMDQzIDEuMjQ5LjAxMyAyLjg2Ny40MiA0LjE4Ni40MDkgMS4zMjQgMS4wOTggMi4xNiAyLjIyNiAyLjI2OHptLTcuOTI3IDIuODE3YzAtMS4zNTQtLjk1My0yLjMzMy0yLjM2OC0yLjQ4OHYtLjA1N2MxLjA0LS4xNjkgMS44NTYtMS4xMzUgMS44NTYtMi4yMTMgMC0xLjUzNy0xLjIxMy0yLjUzOC0zLjA2Mi0yLjUzOGgtNC4xNnYxMC4xNzJoNC4xODFjMi4yMTggMCAzLjU1My0xLjA4NiAzLjU1My0yLjg3NnoiLz48L3N2Zz4="
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 495,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 530
  }, "Bootstrap"), /*#__PURE__*/React.createElement("text", {
    x: 495,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 530
  }, "Bootstrap"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.8d80a6e77b9506f9193d4a0260885829.svg";
export { ForwardRef as ReactComponent };